import { Icon as LegacyIcon } from '@ant-design/compatible'
import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { OrderContext } from '@Orders/OrderDetailsPage/context'
import { selectFlags as selectOrderDetailsFlags } from '@Orders/OrderDetailsPage/selectors'

import Box from '~/core/Box'
import Text from '~/core/Text'
import { getStatus, getPartStatus } from '../logic'
import { OrderedItemsRecordType } from '../types'
import {
    TOOLING_CHANGE_PROCESSES_ID,
    TOOLING_PROCESSES_IDS,
} from '~/lib/partsConstants'

type PartStatusCellPropsType = {
    record: OrderedItemsRecordType
    moldStatus?: string | null
}

type StatusTextPropsType = {
    status: string
    description: string
    marginTop?: string
}

const ProcessText = (props: StatusTextPropsType) => {
    const { status: statusFromProps, description, marginTop = '0px' } = props
    const { status, color, iconType } = getStatus(statusFromProps)

    return (
        <Text color={color} style={{ marginTop }}>
            <LegacyIcon
                type={iconType}
                theme="filled"
                style={{ marginRight: '4px' }}
            />
            {description} {status.toLowerCase() || '--'}
        </Text>
    )
}

const PartStatusCell = ({ record, moldStatus }: PartStatusCellPropsType) => {
    const { isImOrder } = useContext(OrderContext)

    const { isImToolingEnabled } = useSelector(selectOrderDetailsFlags)

    const isTooling = record?.processes.some(
        ({ platformProcessId }) =>
            platformProcessId &&
            (TOOLING_CHANGE_PROCESSES_ID?.indexOf(platformProcessId) >= 0 ||
                TOOLING_PROCESSES_IDS?.indexOf(platformProcessId) >= 0),
    )

    return (
        // Necessary box to keep the content in the center, but text align to left
        <Box
            justifyContent={
                isImOrder && isImToolingEnabled ? 'start' : 'center'
            }
        >
            {!isTooling ? (
                <Box direction="col" alignItems="start" width="auto">
                    <ProcessText
                        {...{
                            description: 'Production',
                            status: getPartStatus(record, moldStatus),
                        }}
                    />
                    <ProcessText
                        {...{
                            description: 'Inspection',
                            status: record.inspectionStatus,
                            marginTop: '6px',
                        }}
                    />
                </Box>
            ) : (
                <Box direction="col" alignItems="start" width="auto">
                    -
                </Box>
            )}
        </Box>
    )
}

export default PartStatusCell
